import { ferrumStakingContract } from 'contracts/contract';

export const ferrumPoolTotalStaked = async (contactAddress: string) => {
  return await ferrumStakingContract(contactAddress).methods.stakedTotal().call();
};
